import { Link } from "react-router-dom";

const stats = [
  { num: "1500万+", label: "注册读者" },
  { num: "3000+", label: "海量漫画" },
  { num: "24h", label: "实时更新" },
  { num: "6种", label: "阅读姿势" },
];

export default function Hero() {
  return (
    <section className="relative flex min-h-[92vh] w-full items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylish%20immersive%20manga%20reading%20illustration%20with%20floating%20comic%20panels%20and%20book%20pages%20in%20warm%20amber%20orange%20and%20deep%20charcoal%20tones%2C%20a%20silhouette%20reading%20on%20a%20glowing%20tablet%2C%20soft%20bokeh%20light%20particles%2C%20cinematic%20editorial%20composition%2C%20rich%20and%20cozy%20atmosphere%2C%20no%20blue%20no%20purple&width=1600&height=900&seq=hero-pufei-01&orientation=landscape"
          alt="扑飞漫画网沉浸式阅读氛围背景图"
          title="扑飞漫画网 · 多种阅读姿势自由切换"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60" />
      </div>

      <div className="relative z-10 flex w-full flex-col items-center px-4 py-28 text-center md:px-8">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-100/30 bg-background-100/10 px-4 py-1.5 text-sm text-background-100 backdrop-blur">
          <i className="ri-flashlight-line text-primary-400" />
          打开就能按习惯看
        </span>

        <h1 className="max-w-3xl text-4xl leading-tight text-background-50 md:text-6xl">
          多种阅读姿势
          <span className="mx-2 inline-block rotate-2 rounded-lg bg-primary-500 px-3 text-background-50">
            自由切换
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
          翻页、下拉、目录跳转、夜间模式、离线缓存、横屏阅读——翻开就能追，翻页顺滑，夜间不刺眼，没网也能看。
        </p>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/features"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            开始阅读 <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/comics"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 bg-background-950/30 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-950/50 sm:w-auto"
          >
            逛逛漫画库
          </Link>
        </div>

        <dl className="mt-14 grid w-full max-w-3xl grid-cols-2 gap-6 md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <dt className="sr-only">{s.label}</dt>
              <dd className="font-heading text-3xl text-background-50 md:text-4xl">{s.num}</dd>
              <dd className="mt-1 text-sm text-background-200">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}